import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setRefreshTokenCookie, setItem } from "lib/Storage";
import useUploadContext from 'hooks/useUploadContext';
import Box from "@mui/material/Box";
import UploadPagBG from "assets/images/upload-page-bg.png";
import LeftSlider from "components/UploadPage/LeftSidebar";
import MainContainer from "components/UploadPage/MainContainer";
import RightSidebar from "components/UploadPage/RightSidebar";
import "./index.scss";

function UploadPage() {

  const location = useLocation();
  const navigate = useNavigate();
  const { audioContextRef } = useUploadContext();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const source = params.get('source');
    if (token && source) {
        setRefreshTokenCookie(token);
        setItem('source', source)
        params.delete('token');
        params.delete('source');
        navigate({
            pathname: location.pathname,
            search: params.toString(),
        }, { replace: true });
    }
  }, [location, navigate]);

  useEffect(() => {
    audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
    return () => {
        audioContextRef.current?.close();
    };
  }, [audioContextRef]);

  return (
    <Box className="screen">
      <Box className="upload-page">
        <Box className="layout-upload-page">
          <Box className="main-wrapper">
            <img
              src={UploadPagBG}
              alt="Upload Page Background"
              className="background"
            />
            <Box className="inner-wrapper">
              <Box className="upload-container">
                <Box className="left-container">
                  <LeftSlider />
                </Box>
                <Box className="center-container">
                  <MainContainer />
                </Box>
                <Box className="right-container">
                  <RightSidebar />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default UploadPage;
